import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { PrivilegeService } from '../privilege/privilege.service';

@Injectable({
  providedIn: 'root',
})
export class PrivilegeGuard implements CanActivate {
  constructor(
    private privilegeService: PrivilegeService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const required: string[] = route.data?.privilege;
    if (!required || required.length === 0) {
      return true;
    }
    const hasAccess = required.some((id) => this.privilegeService.getPrivileges(id));
    if (hasAccess) {
      return true;
    }
    return this.router.parseUrl('/home');
  }
}
